import { useEffect, useRef } from 'react';

import { useSettings } from '@atlas/core';

import { LANG_MAP } from './langMap';

export const useUserSettings = () => {
  const { lang, theme } = useSettings();
  const prev = useRef({ lang, theme });
  useEffect(() => {
    const { lang: prevLang, theme: prevTheme } = prev.current;

    if (prevLang !== lang) {
      window.altenarWSDK?.set({ culture: LANG_MAP[lang] });
    }

    if (prevTheme !== theme) {
      window.altenarWSDK?.set({ themeName: theme });
    }

    prev.current = { lang, theme };
  }, [lang, theme]);
};
